import { render, staticRenderFns } from "./confirm-create-booking.vue?vue&type=template&id=02198889&scoped=true"
import script from "./confirm-create-booking.vue?vue&type=script&lang=js"
export * from "./confirm-create-booking.vue?vue&type=script&lang=js"
import style0 from "./confirm-create-booking.vue?vue&type=style&index=0&id=02198889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02198889",
  null
  
)

export default component.exports